import {Box, Button, Stack, Typography} from '@mui/material';
import {BookingView} from '../types';
import {XCircleIcon} from '$assets/svgs';
import {paymentFailureViewStyles} from '../styles';
import React from 'react';

interface PaymentFailureProps {
  setActiveView: (view: BookingView) => void;
}
function PaymentFailureView({setActiveView}: PaymentFailureProps) {
  const handleTryAgain = () => {
    setActiveView(BookingView.PatientInsuranceDetailView);
  };

  return (
    <Box sx={paymentFailureViewStyles.container}>
      <Stack
        spacing={3}
        alignItems="center"
        sx={paymentFailureViewStyles.stack}
      >
        <Box sx={paymentFailureViewStyles.iconContainer}>
          <XCircleIcon
            style={paymentFailureViewStyles.icon as React.CSSProperties}
          />
        </Box>

        <Typography variant="h1" sx={paymentFailureViewStyles.title}>
          Your payment failed
        </Typography>

        <Typography variant="body2" sx={paymentFailureViewStyles.description}>
          Unfortunately, your payment attempt was unsuccessful. Please note that{' '}
          <strong>no money has been taken from your account</strong>.
          <Box sx={paymentFailureViewStyles.descriptionSpacing}>
            If you continue to experience issues, feel free to contact us for
            assistance.
          </Box>
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          sx={paymentFailureViewStyles.buttonContainer}
        >
          <Button
            variant="contained"
            color="primary"
            sx={paymentFailureViewStyles.button}
            onClick={handleTryAgain}
          >
            Try again
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default PaymentFailureView;
